<template>
  <div class="productSort newsDetail">
    <form @submit.prevent="submitForm">
      <div class="header acea-row row-center-wrapper" ref="header" style="text-align:center;">
        服务花絮
      </div>
    </form>
    <div class="aside">
      <div
          class="item acea-row row-center-wrapper"
          :class="index === navActive ? 'on' : ''"
          v-for="(item, index) in category"
          :key="index"
          @click="asideTap(index)"
      >
        <span>{{ item.show_day }}</span>
      </div>
    </div>
    <div class="conter conter1" @scroll.native="onScroll">
      <div  v-for="(item, index) in category" :key="index">

        <div class="listw" v-if=" selectIndex == index">
          <div class="title acea-row row-center-wrapper" ref="title">
            <div class="name">{{ item.title }}</div>
          </div>

          <div v-if="item.slider_image_count >0">
            <product-con-swiper
                    :img-urls="item.slider_image"
                    :videoline="item.video_link"
            ></product-con-swiper>
          </div>

          <div class="list acea-row listcon"  v-html="item.content"></div>

          <div class="picTxt acea-row row-between-wrapper" v-if="item.storeInfo.id">
            <div class="pictrue"><img :src="item.storeInfo.image" /></div>
            <div class="text">
              <div class="name line1">{{ item.storeInfo.store_name }}</div>

              <div class="money font-color-red" v-if="item.storeInfo.vip_price && item.storeInfo.vip_price > 0">
                ￥<span class="num">{{ item.storeInfo.vip_price }} <span v-if="item.storeInfo.vip_point>0">+{{item.storeInfo.vip_point}}购物券</span><span class="showpvclass">({{ item.storeInfo.show_vip_pv }}pv)</span></span>
              </div>
              <div class="money font-color-red" v-else>
                ￥<span class="num">￥{{ item.storeInfo.price }} <span v-if="item.storeInfo.point>0">+{{item.storeInfo.point}}购物券</span><span class="showpvclass">({{ item.storeInfo.show_pv }}pv)</span></span>
              </div>


              <!--<div class="money font-color-red">
                ￥<span class="num">{{ storeInfo.price }}</span>
              </div>
              <div class="y_money">￥{{ storeInfo.ot_price }}</div>-->
            </div>
            <router-link :to="{ path: '/detail/' + item.storeInfo.id }">
              <div class="label"><span class="span">查看商品</span></div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div style="height:1.2rem;"></div>
  </div>
</template>
<style>
  .listcon {
    margin: 0 0.1rem !important;
  }
</style>
<style scoped>
  .product-bg {
    height:5.4rem;
  }
  .newsDetail .picTxt {
    width: 5rem;
    height: 2rem !important;
    border-radius: 0.2rem;
    border: 1px solid #e1e1e1;
    position: relative;
    margin: 0.3rem auto 0.3rem auto;
  }
  .newsDetail .picTxt .pictrue {
    width: 1.9rem;
    height: 1.9rem;
  }
  .newsDetail .picTxt .pictrue img {
    width: 100%;
    height: 100%;
    border-radius: 0.2rem 0 0 0.2rem;
    display: block;
  }
  .newsDetail .picTxt .text {
    width: 2.6rem;
  }
  .newsDetail .picTxt .text .name {
    font-size: 0.3rem;
    color: #282828;
  }
  .newsDetail .picTxt .text .money {
    font-size: 0.24rem;
    margin-top: 0.4rem;
    font-weight: bold;
  }
  .newsDetail .picTxt .text .money .num {
    font-size: 0.36rem;
  }
  .newsDetail .picTxt .text .y_money {
    font-size: 0.26rem;
    color: #999;
    text-decoration: line-through;
  }
  .newsDetail .picTxt .label {
    position: absolute;
    background-color: #303131;
    width: 1.6rem;
    height: 0.5rem;
    right: -0.07rem;
    border-radius: 0.25rem 0 0.06rem 0.25rem;
    text-align: center;
    line-height: 0.5rem;
    bottom: 0.74rem;
  }
  .newsDetail .picTxt .label .span {
    background-image: linear-gradient(to right, #fff71e 0%, #f9b513 100%);
    background-image: -webkit-linear-gradient(to right, #fff71e 0%, #f9b513 100%);
    background-image: -moz-linear-gradient(to right, #fff71e 0%, #f9b513 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .newsDetail .picTxt .label:after {
    content: " ";
    position: absolute;
    width: 0;
    height: 0;
    border-bottom: 0.08rem solid #303131;
    border-right: 0.08rem solid transparent;
    top: -0.08rem;
    right: 0;
  }
  .newsDetail .bnt {
    color: #fff;
    font-size: 0.3rem;
    width: 6.9rem;
    height: 0.9rem;
    border-radius: 0.45rem;
    margin: 0.48rem auto 0 auto;
    text-align: center;
    line-height: 0.9rem;
  }
</style>
<script>
  import ProductConSwiper from "@components/ProductConSwiper";
import debounce from "lodash.debounce";
import { getNote } from "@api/store";
import { trim } from "../../utils";
import { mapGetters } from "vuex";
import { isWeixin } from "@utils/index";
import { getHomeData, getShare, follow } from "@api/public";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { getUser,getUserOpenId, getMenuUser } from "@api/user";
export default {
  name: "Note",
  components: {ProductConSwiper},
  props: {},
  data: function() {
    return {
      category: [],
      navActive: 0,
      selectIndex:0,
      search: "",
      lock: false
    };
  },
  watch: {
    "$route.params.pid": function(n) {
      if (n) {
        this.activeCateId(n);
      }
    }
  },
  computed: mapGetters(["isLogin"]),
  mounted: function() {
    document.addEventListener("scroll", this.onScroll, false);
    this.loadCategoryData();
    this.setOpenShare();
  },
  methods: {
    activeCateId(n) {
      let index = 0;
      n = parseInt(n);
      if (!n) return;
      this.category.forEach((cate, i) => {
        if (cate.id === n) index = i;
      });

      if (index !== this.navActive) {
        this.asideTap(index);
      }
    },
    loadCategoryData() {
      getNote().then(res => {
        this.category = res.data;
        this.$nextTick(() => {
          if (this.$route.params.pid) this.activeCateId(this.$route.params.pid);
          else this.onScroll();
        });
      });
    },
    submitForm: function() {
      var val = trim(this.search);
      if (val) {
        this.$router.push({
          path: "/goods_list",
          query: { s: val }
        });
        setTimeout(() => (this.search = ""), 500);
      }
    },
    asideTap(index) {
      this.selectIndex = index;
      /*const top =
          this.$refs.title[index].offsetTop -
          this.$refs.header.offsetHeight -
          window.scrollY;

      this.lock = true;

      window.scrollBy({ top, left: 0, behavior: "smooth" });*/
      this.navActive = index;
    },
    onScroll: debounce(function() {
      if (this.lock) {
        this.lock = false;
        return;
      }
      const headerHeight = this.$refs.header.offsetHeight,
          { scrollY } = window,
          titles = this.$refs.title;
      titles.reduce((initial, title, index) => {
        if (initial) return initial;
        const parent = title.parentNode || title.parentElement;
        if (
            scrollY + headerHeight + 15 <
            title.offsetTop + parent.offsetHeight
        ) {
          initial = true;
          this.navActive = index;
        }
        return initial;
      }, false);
    }, 500),

    setOpenShare() {
      if (isWeixin()) {
        if(this.isLogin){

          getUser().then(res => {
            var href = location.href;

            href =
                href.indexOf("?") === -1
                    ? href + "?spread=" + res.data.uid
                    : href + "&spread=" + res.data.uid;
            var nickname = res.data.nickname;


            getShare().then(res => {
              var data = res.data.data;
              var configAppMessage = {
                desc: '['+nickname+'邀请] '+data.synopsis,
                title: data.title,
                link: href,
                imgUrl: data.img
              };
              openShareAll(configAppMessage);
            });
          })
        }else{
          getShare().then(res => {
            var data = res.data.data;
            var configAppMessage = {
              desc: data.synopsis,
              title: data.title,
              link: location.href,
              imgUrl: data.img
            };
            openShareAll(configAppMessage);
          });
        }


      }
    }
  },
  beforeDestroy: function() {
    document.removeEventListener("scroll", this.onScroll, false);
  }

};
</script>
